import React, { Component } from "react";
import TopOptions from "../components/TopOptions";
import AssociationsTable from "../components/AssociationsTable";
import styled from "styled-components";
import { connect } from "react-redux";
import { RoutesPath } from "../values/RoutesPath";
import { acl } from "../services/acl";

class AssociationsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: false,
        };
    }
    async componentDidMount() {
        document.title = "Ressources - Sobrus Labs";
        //(this.props)
    }
    render() {
        return (
            <Main_container className="Main_container">
                <TopOptions title="Associations">
                    {acl.resource.suggestion.associations.list() && (
                        <a onClick={() => this.props.history.push(`${RoutesPath.resource.suggestion.associations.list}`)} className="btn_white">
                            Historique des suggestions
                        </a>
                    )}
                    {acl.resource.suggestion.associations.add() && (
                        <button className="btn_bleu" data-shortcut_alias="create" onClick={() => this.props.history.push(`${RoutesPath.resource.suggestion.associations.add}`)}>
                            Suggérer une nouvelle association
                        </button>
                    )}
                </TopOptions>

                <AssociationsTable {...this.props} />
            </Main_container>
        );
    }
}

const Main_container = styled.div`
    height: 100%;
`;
const mapStateToProps = (state) => {
    return {
        selected: state.selcted,
    };
};
export default connect(mapStateToProps)(AssociationsPage);
